import { useState } from "react";
import { Menu, X, ChevronDown } from "lucide-react";
import { Link } from "@/lib/router-compat";
import { Button } from "@/components/ui/button";
import { useContactForm } from "@/contexts/ContactFormContext";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import logo from "@/assets/Logo_Blue.webp";

const whoWeServeItems = [
  { label: "Pharmacies & Drugstores", to: "/pharmacy" },
  { label: "Frame Suppliers", to: "/brands-resellers" },
  { label: "Opticians", to: "/opticians" },
  { label: "Dropshippers", to: "/dropshipping" },
];

const Navbar = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [mobileSubOpen, setMobileSubOpen] = useState(false);
  const { openContactForm } = useContactForm();

  return (
    <nav className="sticky top-0 z-50 border-b border-border bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="container mx-auto flex h-16 items-center justify-between">
        <Link to="/" className="flex items-center">
          <img src={logo} alt="GoHub" width="103" height="44" className="h-11 w-auto" />
        </Link>

        {/* Desktop */}
        <div className="hidden items-center gap-6 md:flex">
          <DropdownMenu>
            <DropdownMenuTrigger className="flex items-center gap-1 text-sm font-medium text-foreground hover:text-primary transition-colors outline-none">
              Who We Serve <ChevronDown size={14} />
            </DropdownMenuTrigger>
            <DropdownMenuContent align="start">
              {whoWeServeItems.map((item) => (
                <DropdownMenuItem key={item.to} asChild>
                  <Link to={item.to} className="cursor-pointer">
                    {item.label}
                  </Link>
                </DropdownMenuItem>
              ))}
            </DropdownMenuContent>
          </DropdownMenu>

          <Link to="/virtual-try-on" className="text-sm font-medium text-foreground hover:text-primary transition-colors">
            Virtual Try-On
          </Link>
          <Link to="/blog" className="text-sm font-medium text-foreground hover:text-primary transition-colors">
            Blog
          </Link>
          <Button size="sm" onClick={() => openContactForm("contact")}>Contact Us</Button>
          <a href="https://app.goptichub.com/login" target="_blank" rel="noopener noreferrer">
            <Button variant="ghost" size="sm" className="text-muted-foreground text-xs">
              Sign In
            </Button>
          </a>
        </div>

        {/* Mobile toggle */}
        <button className="md:hidden" onClick={() => setMobileOpen(!mobileOpen)}>
          {mobileOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile menu */}
      {mobileOpen && (
        <div className="border-t border-border bg-background px-4 pb-4 md:hidden">
          <div className="flex flex-col gap-3 pt-3">
            <button
              className="flex items-center justify-between text-sm font-medium text-foreground"
              onClick={() => setMobileSubOpen(!mobileSubOpen)}
            >
              Who We Serve <ChevronDown size={14} className={`transition-transform ${mobileSubOpen ? "rotate-180" : ""}`} />
            </button>
            {mobileSubOpen && (
              <div className="flex flex-col gap-2 pl-4">
                {whoWeServeItems.map((item) => (
                  <Link
                    key={item.to}
                    to={item.to}
                    className="text-sm text-muted-foreground hover:text-foreground"
                    onClick={() => setMobileOpen(false)}
                  >
                    {item.label}
                  </Link>
                ))}
              </div>
            )}
            <Link to="/virtual-try-on" className="text-sm font-medium text-foreground" onClick={() => setMobileOpen(false)}>
              Virtual Try-On
            </Link>
            <Link to="/blog" className="text-sm font-medium text-foreground" onClick={() => setMobileOpen(false)}>Blog</Link>
            <Button size="sm" className="w-fit" onClick={() => { openContactForm("contact"); setMobileOpen(false); }}>
              Contact Us
            </Button>
            <a href="https://app.goptichub.com/login" target="_blank" rel="noopener noreferrer" className="text-sm text-muted-foreground hover:text-foreground" onClick={() => setMobileOpen(false)}>
              Sign In
            </a>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
